const GIFT_CARD_STATUS = {
  REQUESTED: 'REQUESTED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export default GIFT_CARD_STATUS;
